if (!window.tridooVideoStorie) {
  window.tridooVideoStorie = true;
  function refresh(root = document) {
    root.querySelectorAll('.kb-brand__video-rail').forEach(rail => {
      if (rail.dataset.ready) return;
      rail.dataset.ready = 'true';
      const section = rail.closest('.kb-brand--videos');
      const buttons = section.querySelectorAll('[data-kb-scroll]');
      const update = () => buttons.forEach(button => {
        const start = parseFloat(getComputedStyle(rail).paddingInlineStart) || 0;
        button.disabled = button.dataset.kbScroll === '-1'
          ? rail.scrollLeft <= start + 2 : rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      });
      buttons.forEach(button => button.addEventListener('click', () => {
        const card = rail.querySelector('.kb-brand__video-card');
        const distance = card ? card.getBoundingClientRect().width + 24 : rail.clientWidth;
        rail.scrollBy({ left: Number(button.dataset.kbScroll) * distance,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }));
      rail.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(rail);
      update();
    });
  }
  document.addEventListener('play', event => {
    if (!event.target.matches('.kb-brand__video')) return;
    document.querySelectorAll('.kb-brand__video').forEach(video => {
      if (video !== event.target) video.pause();
    });
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => refresh());
  else refresh();
  document.addEventListener('shopify:section:load', event => refresh(event.target));
}
